import React from 'react';
import { Shield, Award, Zap, Building2 } from 'lucide-react';

const TrustBar = () => {
  const trustItems = [
    { icon: Shield, text: 'Fully Certified Engineers' },
    { icon: Award, text: 'Fully Insured & Liability Covered' },
    { icon: Zap, text: 'Emergency Response' },
    { icon: Building2, text: 'Residential & Commercial Coverage' },
  ];

  return (
    <section className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 py-8 border-y border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustItems.map((item, index) => (
            <div 
              key={index}
              className="flex items-center justify-center space-x-3 p-4 rounded-lg hover:bg-gray-700/30 transition-all duration-300"
            >
              <item.icon className="w-6 h-6 text-amber-500 flex-shrink-0" />
              <p className="text-sm text-gray-200 font-medium">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
